import { render, staticRenderFns } from "./GreenSupplyChain.vue?vue&type=template&id=d1b9d9c0&scoped=true&"
import script from "./GreenSupplyChain.vue?vue&type=script&lang=js&"
export * from "./GreenSupplyChain.vue?vue&type=script&lang=js&"
import style0 from "./GreenSupplyChain.vue?vue&type=style&index=0&id=d1b9d9c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b9d9c0",
  null
  
)

export default component.exports